import React from 'react';
import { Container, Paper } from '@mui/material';
import AddressValidateForm from '../AddressValidateForm';

export default function ValidateAddressContainer() {
  return (
    <Container maxWidth="xl" style={{ height: 'calc(100% - 65px)', paddingTop: '10px' }}>
      <Paper elevation={2}>
        <Container maxWidth="xl" style={{ padding: '15px' }}>
          <AddressValidateForm />
        </Container>
      </Paper>
    </Container>
  );
}
